/**
 * HumiditySetting Style01 - Slider style: humidity
 * min/max from attributes.humiditySetpointRange
 */
import { useState, useEffect, useMemo } from 'react'
import type { TraitControlProps } from './types'
import { resolveRangeFromAttributes } from './traitStyleConfig'
import './HumiditySettingStyle01.css'

export function HumiditySettingStyle01({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { min: MIN, max: MAX } = useMemo(
    () => resolveRangeFromAttributes(attributes, trait, 'humidity'),
    [attributes, trait]
  )
  const raw = (state?.humidity ?? state?.rh) as number | undefined
  const current = typeof raw === 'number' ? Math.max(MIN, Math.min(MAX, Math.round(raw))) : Math.round((MIN + MAX) / 2)
  const [humidity, setHumidity] = useState(current)

  useEffect(() => {
    const v = typeof raw === 'number' ? Math.max(MIN, Math.min(MAX, Math.round(raw))) : Math.round((MIN + MAX) / 2)
    setHumidity(v)
  }, [raw, MIN, MAX])

  const handleChange = (value: number) => {
    const safe = Math.max(MIN, Math.min(MAX, Math.round(value)))
    setHumidity(safe)
    void onCommand('setHumidity', { humidity: safe })
  }

  return (
    <div className="trait-humidity-style01">
      <label htmlFor="humidity-style01-slider" className="trait-humidity-style01__label">
        Humidity
      </label>
      <input
        id="humidity-style01-slider"
        type="range"
        min={MIN}
        max={MAX}
        value={humidity}
        onChange={(e) => setHumidity(Number(e.target.value))}
        onMouseUp={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        onTouchEnd={(e) => handleChange(Number((e.target as HTMLInputElement).value))}
        className="trait-humidity-style01__slider"
        disabled={disabled}
        style={{
          background: `linear-gradient(to right, #06b6d4 0%, #06b6d4 ${((humidity - MIN) / (MAX - MIN)) * 100}%, rgba(255,255,255,0.20) ${((humidity - MIN) / (MAX - MIN)) * 100}%, rgba(255,255,255,0.20) 100%)`,
        }}
      />
      <span className="trait-humidity-style01__value">{humidity}%</span>
    </div>
  )
}
